/**
 * Round a number to 2 decimal cases.
 *
 * @example
 *
 *   roundTo2DecimalPlaces(2);
 *   // 2
 *   roundTo2DecimalPlaces(1.9);
 *   // 1.9
 *   roundTo2DecimalPlaces(1.99);
 *   // 1.99
 *   roundTo2DecimalPlaces(1.993);
 *   // 1.99
 *   roundTo2DecimalPlaces(1.997);
 *   // 2
 *
 */
export const roundTo2DecimalPlaces = (input: number): number => Math.round(input * 100) / 100;
